import { ReactNode } from "react";
import Classes from "./Container.module.scss";
import cx from "classnames";

type ContainerProps = {
  children: ReactNode;
  className: string;
};

const Container = ({ children, className }: ContainerProps) => {
  return (
    <div className={cx(Classes.container, { [className]: className })}>
      {children}
    </div>
  );
};

export default Container;
